export const pushEcommerce = (data) => {
  try {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });
    dataLayer.push(data);
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerCheckoutOption = (step, checkoutOption) => {
  pushEcommerce({
    'event': 'checkoutOption',
    'ecommerce': {
      'checkout_option': {
        'actionField': { 'step': step, 'option': checkoutOption }
      }
    }
  });
}

export const dataLayerAddToCart = (gtmEcommerceItems) => {
  pushEcommerce({
    event: "gtm_add_to_cart",
    ecommerce: {
      items: gtmEcommerceItems
    }
  });
}

export const dataLayerGtmViewCart = (cart) => {
  pushEcommerce({
    'event': 'gtm_view_cart',
    'ecommerce': {
      'currency': cart.currency,
      'value': cart.gtmGrandTotal,
      'items': cart.orderRows.map(r => r.gtmEcommerceItem),
    },
  });
}